import client from './client';

export const uploadApi = {
  uploadProductImage: (file, productCode) => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('productCode', productCode);

    return client.post('/upload/product-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  uploadRecipeImage: (file, imageName) => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('imageName', imageName);

    return client.post('/upload/recipe-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  uploadIngredientImage: (file, imageName) => {
    const formData = new FormData();
    formData.append('image', file);
    formData.append('imageName', imageName);

    return client.post('/upload/ingredient-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  deleteProductImage: (productCode) => {
    return client.delete(`/upload/product-image/${productCode}`);
  }
};
